export type UsersSearchFilters = {
  status?: UserStatus[]
  roleId?: number[]
}

export enum UserStatus {
  ACTIVATED = 'activated',
  NOT_ACTIVATED = 'not_activated',
  DEACTIVATED = 'deactivated',
}
